import React from 'react';
import BlocksGridActions from './BlocksGridActions';

const blocksGridColumns = [
    {
        id: 'id',
        Header: 'Id',
        accessor: 'id',
        width: 70,
    },
    {
        id: 'is_enabled',
        Header: 'Enabled',
        accessor: 'is_enabled',
        show: false,
    },
    {
        Header: 'Name',
        accessor: 'display_name',
    },
    {
        Header: 'Title',
        accessor: 'title',
        Cell: (props) =>
            props.value === '' ? <span> - </span> : <span>{props.value}</span>,
    },
    {
        Header: 'Block Type',
        accessor: 'block_type_name',
        Cell: (props) => <span>{props.value}</span>,
    },
    {
        Header: 'Destination',
        accessor: 'destination_name',
        Cell: (props) =>
            props.value === null ? (
                <span> - </span>
            ) : (
                <span>{props.value}</span>
            ),
    },
    {
        Header: 'Trip Format',
        accessor: 'trip_format_name',
        Cell: (props) =>
            props.value === null ? (
                <span> - </span>
            ) : (
                <span>{props.value}</span>
            ),
    },
    {
        Header: 'Type of Work',
        accessor: 'type_of_work_name',
        Cell: (props) =>
            props.value === null ? (
                <span> - </span>
            ) : (
                <span>{props.value}</span>
            ),
    },
    {
        Header: 'Actions',
        width: 150,
        sortable: false,
        Cell: (props) => <BlocksGridActions props={props} />,
    },
];

export default blocksGridColumns;



// WEBPACK FOOTER //
// ./src/containers/blocks/BlocksGridColumns.jsx